import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('sheet_rates_reviews', '/sheet_rates_reviews')
const actions = generator.generate()

export default actions
